export default {
  sendMessagePlaceholder: "Envoyer un message à l'équipe de chasse",
  readMessagesErrorMessage: "Impossible de charger tous les messages. Veuillez réessayer.",
  sendMessageErrorMessage: "Une erreur s'est produite et le message n'a pas pu être envoyé. Veuillez réessayer."
}
